/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-require-imports */
import React, {FC, useEffect, useState} from 'react';
import {
  Image,
  Platform,
  StyleProp,
  Text,
  TextInput,
  TouchableOpacity,
  View,
  ViewStyle,
} from 'react-native';
import {thousandSeparator} from '../../../../data/factory';
import {formsStyles} from '../formStyles';
import styles from '../styles';
import localStyle from './styles';
import {TitleLabel} from './TitleLabel';

interface Props {
  label?: string | React.ReactNode;
  required?: boolean;
  value?: any;
  onChange?: any;
  name?: any;
  error?: any;
  showError?: boolean;
  onBlur?: any;
  onFocus?: any;
  maxLength?: any;
  type?: string;
  isEditable?: boolean;
  onSubmitEditing?: any;
  placeholder?: string;
  style?: StyleProp<ViewStyle>;
  inputStyle?: StyleProp<ViewStyle>;
}
export const InputField: FC<Props> = ({
  label = '',
  required = false,
  value = '',
  onChange,
  name = '',
  error = '',
  showError = false,
  onBlur,
  onFocus,
  maxLength = 500,
  type = '',
  isEditable = true,
  onSubmitEditing,
  placeholder = '',
  style,
  inputStyle,
}) => {
  const handleChange = (name: string, value: string) => {
    let bSend = true;
    let data = value;

    if (type === 'numeric') {
      data = value.replace(/[^0-9]/g, '').toString();
    }
    if (type === 'alphanumeric') {
      data = value.replace(/[^A-Za-z0-9\s]/g, '').toString();
    }

    if (type === 'anneeScolaire') {
      data = value.replace(/[^0-9-]/g, '').toString();
    }
    if (type === 'price') {
      data = value.replace(/[^0-9]/g, '').toString();
      data = thousandSeparator(data, ' ');
    }
    if (type === 'telephone') {
      data = value.replace(/[^0-9]/g, '').toString();
      if (data.length > 10) {
        bSend = false;
      }
    }

    bSend && onChange(name, data, true);
  };

  const [isPasswordShown, setIsPasswordShown] = useState(false);
  const [errorToDisplay, setErrorToDisplay] = useState(error);
  const keyboardType =
    type === 'anneeScolaire'
      ? Platform.OS === 'ios'
        ? 'numbers-and-punctuation'
        : 'phone-pad'
      : 'default';

  useEffect(() => {
    setTimeout(() => {
      setErrorToDisplay(error);
    }, 150);
  }, [error]);

  return (
    <View style={[styles.container, style]}>
      <TitleLabel label={label} required={required} />
      <View
        style={[
          type === 'textArea'
            ? formsStyles.itemInputStyleTextArea
            : formsStyles.itemInputStyle,
          required && showError && error !== '' ? formsStyles.inputError : {},
          {
            backgroundColor: isEditable
              ? '#ffffff'
              : 'rgba(240, 244, 248, 0.87)',
          },
          inputStyle,
        ]}>
        <TextInput
          style={localStyle.textIput}
          textAlignVertical={type === 'textArea' ? 'top' : 'center'}
          value={value}
          multiline={type === 'textArea'}
          numberOfLines={9}
          onChangeText={(value: string) => handleChange(name, value)}
          onBlur={onBlur}
          onFocus={onFocus}
          maxLength={maxLength}
          editable={isEditable}
          secureTextEntry={type === 'password' && !isPasswordShown}
          keyboardType={
            type === 'numeric' || type === 'telephone' || type === 'price'
              ? 'numeric'
              : keyboardType
          }
          onSubmitEditing={onSubmitEditing}
          placeholder={placeholder}
          placeholderTextColor={'gray'}
        />

        {type === 'password' ? (
          <TouchableOpacity
            onPress={() => {
              setIsPasswordShown(!isPasswordShown);
            }}>
            <View style={localStyle.passwordContainer}>
              {isPasswordShown ? (
                <Image
                  style={[formsStyles.iconEye]}
                  source={require('../../../../ressources/images/Show.png')}
                />
              ) : (
                <Image
                  style={[formsStyles.iconEye]}
                  source={require('../../../../ressources/images/Shownot.png')}
                />
              )}
            </View>
          </TouchableOpacity>
        ) : null}
      </View>
      {required && showError && errorToDisplay !== '' && (
        <Text style={styles.textError}>{errorToDisplay}</Text>
      )}
    </View>
  );
};
